import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import PermisosListSelect from "../Permisos/PermisosListSelect.js"


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre: 0,
            permisos_checked: [],
            permisos_disabled: []
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    ResetForm() {
        this.setState({
            padre: 0,
            permisos_checked: [],
            permisos_disabled: []
        });
    }

    groupChanged(value) {
        this.setState({
            padre: value.pk,
            permisos_disabled: value.permisos
        });
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.perfiles.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Perfil de Usuario ha sido creado con éxito."}
                title={"Nuevo Perfil de Usuario"}
                buttonTitle={"Nuevo Perfil de Usuario"}
                buttonIcon={"fa fa-plus fa-lg"}

                saveButton={true}
                closeButton={true}
                onClose={() => this.ResetForm()}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Padre</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker value={this.state.padre} onChange={(value) => this.groupChanged(value)} fieldName={"padre_id"} url={api.usuarios.grupos.select} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-12">
                        <Label>Permisos</Label>
                        <PermisosListSelect fieldName={"permisos"} disabledNodes={this.state.permisos_disabled} onChange={(value) => this.setState({ permisos_checked: value })} checked={this.state.permisos_checked} />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Perfiles/Create.js